import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
} else {
  /*
   * Mock GTM dataLayer on global windows object
   * in development environment
   */
  const windowService: any = window;
  windowService.dataLayer = [];
}

platformBrowserDynamic().bootstrapModule(AppModule);
